var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5958_2487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4738 15.0525C1.64367 16.4208 2.74905 17.5016 4.12038 17.6451C6.01795 17.8434 7.98461 18.0528 9.99998 18.0528C12.0154 18.0528 13.982 17.8434 15.8796 17.6451C17.2508 17.5016 18.3563 16.4208 18.5261 15.0525C18.729 13.4188 18.9286 11.7294 18.9286 10C18.9286 8.27069 18.729 6.58125 18.5261 4.94762C18.3563 3.57934 17.2508 2.49842 15.8796 2.35507C13.982 2.15671 12.0154 1.94727 9.99998 1.94727C7.98461 1.94727 6.01794 2.15671 4.12038 2.35507C2.74905 2.49842 1.64367 3.57934 1.47378 4.94762C1.27097 6.58125 1.07141 8.27069 1.07141 10C1.07141 11.7294 1.27097 13.4188 1.4738 15.0525Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.51367 4.57764L8.23099 9.87401C9.26847 10.692 10.7315 10.692 11.769 9.87401L18.4863 4.57764",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5958_2487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f65958742ac973f4c4dac7f0707c2ff6.svg";
export { ForwardRef as ReactComponent };